export default "__VITE_ASSET__7ed7d2bb__"